import { useEffect } from 'react';
import { useApp } from '../context/AppContext';
import {
  onAnalysisComplete,
  onAnalysisError,
  getAnalysisStatus,
} from '../services/orchestrator/analysisOrchestrator';
import { persistCaptainOutput } from '../services/firestore/analysisService';

/**
 * Bridges the analysis orchestrator (module-level singleton) to React state.
 * On completion: dispatches SET_LAB_REPORT + SET_ANALYSIS_STATUS.
 * On error: dispatches SET_ANALYSIS_ERROR + SET_ANALYSIS_STATUS.
 */
export function useBackgroundAnalysis() {
  const { state, dispatch } = useApp();

  useEffect(() => {
    const unsubComplete = onAnalysisComplete((report) => {
      dispatch({ type: 'SET_LAB_REPORT', payload: report });
      dispatch({ type: 'SET_ANALYSIS_STATUS', payload: 'completed' });
      persistCaptainOutput(report).catch((err) => console.warn('[MCP Persist] Captain write failed:', err));
    });

    const unsubError = onAnalysisError((errMsg) => {
      dispatch({ type: 'SET_ANALYSIS_ERROR', payload: errMsg });
      dispatch({ type: 'SET_ANALYSIS_STATUS', payload: 'failed' });
    });

    // Sync current status on mount (in case analysis completed before hook mounted)
    const currentStatus = getAnalysisStatus();
    if (currentStatus !== state.analysisStatus && currentStatus !== 'idle') {
      dispatch({ type: 'SET_ANALYSIS_STATUS', payload: currentStatus });
    }

    return () => {
      unsubComplete();
      unsubError();
    };
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return {
    isAnalysisReady: state.analysisStatus === 'completed',
    analysisStatus: state.analysisStatus,
    analysisError: state.analysisError,
  };
}
